import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, Award, Shield, Zap } from 'lucide-react';

const FilloutExpertiseSection = () => {
  const { t } = useTranslation('fillout');

  const expertiseData = t('expertise.items', { returnObjects: true });
  const expertise = Array.isArray(expertiseData) ? expertiseData as Array<{
    title: string;
    description: string;
  }> : [];

  const expertiseIcons = [Award, Zap, Shield, CheckCircle];
  const expertiseColors = ["text-yellow-500", "text-blue-500", "text-green-500", "text-purple-500"];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-3 sm:space-y-4 mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold">
            {t('expertise.title')}
          </h2>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('expertise.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {expertise.map((item, index) => {
            const IconComponent = expertiseIcons[index];
            const colorClass = expertiseColors[index];
            return (
              <Card key={index} className="text-center group hover:shadow-xl transition-all duration-300 border-primary/10 hover:border-primary/30">
                <CardHeader className="space-y-4 p-4 sm:p-6">
                  <div className="mx-auto w-16 h-16 bg-gradient-to-br from-primary/10 to-primary/20 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className={`w-8 h-8 ${colorClass}`} />
                  </div>
                  <CardTitle className="text-lg sm:text-xl group-hover:text-primary transition-colors">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-4 sm:p-6 pt-0">
                  <p className="text-sm sm:text-base text-muted-foreground">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FilloutExpertiseSection;